<mat-form-field class="search-input-form-field" [class.berry-border]="isFocused" appearance="outline">
  <input
    matInput
    [placeholder]="'Module.Header.Search' | transloco"
    [matAutocomplete]="auto"
    autocomplete="off"
    [(ngModel)]="internalSearchTerm"
    (keyup)="addressChanged($event)"
    (focus)="openAutocompleteIfSuggestions(); onFocus()"
    (blur)="onBlur()"
    data-testid="module.header.search.input"
  />
  <mat-icon
    matPrefix
    color="primary"
    fontSet="material-symbols-outlined"
    style="cursor: pointer"
    (click)="$event.stopPropagation(); headerLocationService.isGlobalSearchMode = !headerLocationService.isGlobalSearchMode"
    onKeyPress="$event.stopPropagation(); headerLocationService.isGlobalSearchMode = !headerLocationService.isGlobalSearchMode"
    [matTooltip]="(headerLocationService.isGlobalSearchMode ? 'Module.Header.SearchGlobal' : 'Module.Header.SearchLocal') | transloco"
  >
    {{ headerLocationService.isGlobalSearchMode ? "language" : "near_me" }}
  </mat-icon>

  <div class="flex items-center gap-2">
    @if (internalSearchTerm().length > 0) {
      <button mat-icon-button (click)="clearSearch(); $event.stopPropagation()" class="!p-0">
        <mat-icon svgIcon="icn-close" />
      </button>
    }

    @if (!isFocused && !internalSearchTerm().length) {
      <div class="rounded-full bg-primary-accumin-purple-100 w-8 h-8 p-2 flex items-center justify-center text-primary-accumin-white">
        <mat-icon svgIcon="icn-search" matSuffix />
      </div>
    }
  </div>

  <mat-autocomplete
    #auto="matAutocomplete"
    class="!max-h-full"
    (optionSelected)="selectAddressByAutocomplete($event)"
    [autoActiveFirstOption]="true"
    panelWidth="auto"
    [displayWith]="displayWithFn"
    data-testid="module.header.search.autocomplete"
  >
    <div class="m-4 px-2 max-h-[90vh] overflow-y-auto" data-testid="module.header.search.autocomplete.container">
      <!-- First Stage: Address Suggestions -->
      @if (
        headerLocationService.showSuggestions() &&
        !headerLocationService.showAddressLookup() &&
        !headerLocationService.isLoadingLookup() &&
        !headerLocationService.hasLookupError()
      ) {
        @if (headerLocationService.suggestions()?.length > 0) {
          <h4 class="text-sm font-medium mb-6">
            {{ "Module.Header.SelectLocation" | transloco }}
          </h4>
          @if (headerLocationService.suggestions()?.length > 0) {
            @for (option of headerLocationService.suggestions(); track option.Description; let i = $index) {
              <mat-option
                [value]="option"
                class="!bg-primary-accumin-black-05 !text-primary-accumin-purple-100 !font-medium rounded-lg my-2 cursor-pointer transition-colors duration-200 hover:bg-accumin-sky-100 hover:text-primary-accumin-purple-100 focus:outline-none focus:ring-2 focus:ring-primary-accumin-purple-100"
                [matTooltip]="option.Description"
              >
                <div class="text-ellipsis line-clamp-1 w-100">
                  {{ option.Description }}
                </div>
              </mat-option>
            }
          }
        } @else {
          <mat-option disabled class="!bg-primary-accumin-black-05 !text-primary-accumin-purple-100 !font-medium rounded-lg my-2">
            {{ "Module.Header.NoSearchResults" | transloco }}
          </mat-option>
        }
      }

      <!-- Loading Stage: Between First and Second Stage -->
      @if (headerLocationService.isLoadingLookup()) {
        <!-- Hidden option to keep autocomplete open -->
        <mat-option style="display: none" />
        <div class="flex flex-col items-center justify-center py-8">
          <mat-spinner diameter="40" color="primary" />
          <p class="text-sm text-primary-accumin-black-75 mt-4">
            {{ "General.DataIsLoading" | transloco }}
          </p>
        </div>
      }

      <!-- Error Stage: When Address Lookup fails -->
      @if (headerLocationService.hasLookupError()) {
        <!-- Hidden option to keep autocomplete open -->
        <mat-option style="display: none" />
        <div class="flex flex-col items-center justify-center py-8">
          <mat-icon class="text-red-500 text-5xl mb-4" svgIcon="icn-error" />
          <p class="text-sm text-red-500 text-center mb-4">
            {{ "General.UnexpectedError" | transloco }}
          </p>
        </div>
      }

      <!-- Second Stage: Address Lookup -->
      @if (
        headerLocationService.showAddressLookup() && !headerLocationService.isLoadingLookup() && !headerLocationService.hasLookupError()
      ) {
        <!-- Hidden option to keep autocomplete open -->
        <mat-option style="display: none" />
        <app-address-lookup (createNewObjectClicked)="createNewObject($event)" />
      }
    </div>
  </mat-autocomplete>
</mat-form-field>
